export const Chat = require("../resources/chat.png");
export const Card = require("../resources/card.png");
export const HourGlass = require("../resources/Hourglass.png");
export const ChatWarning = require("../resources/Chat_Warning.png");
export const Logo = require("../resources/logo.png");
export const PCLOGO = require('../resources/PCLOGO.png');
export const Cover = require('../resources/cover.png');
export const LoginBack = require('../resources/loginBack.png');